module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/hero-signup-c39be7163090c0cd96f93cdf479fde82.svg";